import { useEffect, useState } from "react";

export const useMedia = <T>(queries: string[], values: T[], defaultValue: T) => {
	const [value, setValue] = useState(undefined);
	const mediaQueryLists = queries.map((q) => typeof window !== "undefined" && window.matchMedia(q));

	const getValue = () => {
		const index = mediaQueryLists.findIndex((mql) => mql.matches);

		return typeof values[index] !== "undefined" ? values[index] : defaultValue;
	};

	useEffect(() => {
		if (typeof window !== "undefined") {
			const handleResize = () => setValue(getValue);

			mediaQueryLists.forEach((mql) => mql.addEventListener("change", handleResize));
			handleResize();

			return () => mediaQueryLists.forEach((mql) => mql.removeEventListener("change", handleResize));
		}
	}, []);

	return value;
};
